export enum DMN_CATEGORIA {
  ATIVO = "1",
  DESLIGADO = "2",
  AUTOPATROCINIO = "3",
  ASSISTIDO = "4",
  EM_LICENCA = "5",
  DIFERIDO = "6",
}